var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcYoutubeColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "44px",
    viewBox: "0 0 48 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_youtube-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD365",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC023",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1147.000000, -48.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1147.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8344828,0.0827586207 C31.1889666,0.0827586207 37.5944839,0.794482759 41.6275862,1.38758731 C44.1186207,1.74344938 46.1351735,3.64137931 46.6096552,6.13241379 C47.0841368,8.86069076 47.6772414,12.8937931 47.6772414,17.8758621 C47.5586218,22.857931 47.0841368,26.8910334 46.6096552,29.6193103 C46.1351735,32.1103448 44.1186207,34.0082748 41.6275862,34.3641368 C37.7131034,34.9572414 31.1889666,35.6689655 23.8344828,35.6689655 C16.5986218,35.6689655 10.0744817,34.9572414 6.04137931,34.3641368 C3.55034483,34.0082748 1.533792,32.1103448 1.05931034,29.6193103 C0.58482869,26.8910334 0.110343724,22.857931 0.110343724,17.8758621 C0.110343724,12.8937931 0.584825379,8.86069076 1.05931034,6.13241379 C1.533792,3.64137931 3.55034483,1.74344938 6.04137931,1.38758731 C9.95586207,0.794482759 16.4799989,0.0827586207 23.8344828,0.0827586207 Z M19.0896563,9.57241159 L19.0896563,26.1793092 L33.324139,17.8758588 L19.0896563,9.57241159 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutubeColor);
export default __webpack_public_path__ + "static/media/ic_youtube-color.b1f3cf237fe676cc1ff8b171f7e7beba.svg";
export { ForwardRef as ReactComponent };